/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAaa_b2c_order_historyViewProps } from './aaa_b2c_order_history';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { IImageSettings, Image } from '@msdyn365-commerce/core';

export default (props: IAaa_b2c_order_historyViewProps) => {
    const style: any = {
        pagination: {
            marginRight: '70px',
            marginBottom: '20px'
        },
        a: {
            color: 'black',
            float: 'left',
            padding: '8px 16px',
            textDecoration: 'none',
            transition: 'background-color .3s',
            border: '1px solid #ddd',
            cursor: 'pointer'
        },
        active: {
            backgroundColor: '#031C36',
            color: 'white',
            border: '1px solid #031C36'
        },
        hover: {
            backgroundColor: '#ddd'
        },
        disabled: {
            backgroundColor: '#eeeeee',
            cursor: 'not-allowed'
        },
        searchInput: {
            height: '37px',
            width: '300px',
            marginRight: '10px'
        }
    };
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            lg: { q: 'w=100&h=100&m=6', w: 100, h: 100 },
            xl: { q: 'w=100&h=100&m=6', w: 100, h: 100 }
        },
        lazyload: true,
        cropFocalRegion: true
    };
    return (
        <>
            {props.requestOrderLines.length > 0 && !props.isLoading && (
                <div className='manage-order-search'>
                    <input
                        type='text'
                        placeholder='Search..'
                        value={props.searchString}
                        onChange={(event: any) => props.handleOnChangeInput(event.target.value)}
                    />
                    <Button
                        className='ms-wishlist-items__product-add-button manage-search'
                        title={'search'}
                        onClick={() => props.searchItems()}
                    >
                        {'Search'}
                    </Button>
                    <Button className='ms-wishlist-items__product-add-button' title={'search'} onClick={() => props.resetItems()}>
                        {'Reset'}
                    </Button>
                    <h4 className='manage-order-count'>
                        {props.searchString
                            ? `${props.searchPageItems.length} / ${props.requestOrderLines.length}`
                            : props.requestOrderLines.length}{' '}
                        Items Available
                    </h4>
                </div>
            )}
            <div className='manage-order-table-content'>
                <table className='manage-order-table'>
                    {props.currentPageItems.length > 0 && (
                        <tr>
                            <th key={'image'} />
                            {props.headers.map((h: string, index: number) => {
                                return <th key={index}>{h}</th>;
                            })}
                        </tr>
                    )}
                    {props.currentPageItems.map((line: any, index: number) => {
                        return (
                            <tr key={index}>
                                <td style={{ width: 200 }}>
                                    <Image
                                        requestContext={props.context.actionContext.requestContext}
                                        altText={line.productName}
                                        title={line.productName}
                                        src={line.imageUrl}
                                        fallBackSrc={line.fallbackImage}
                                        gridSettings={props.context.request.gridSettings!}
                                        imageSettings={defaultImageSettings}
                                        loadFailureBehavior={'empty'}
                                    />
                                </td>
                                <td style={{ width: 214 }}>{line.stockistName}</td>
                                <td style={{ width: 160 }}>{line.orderNumber}</td>
                                <td
                                    style={{
                                        width: 170,
                                        marginTop: line.orderLinesPriceInfo.length > 0 ? 45 : 0
                                    }}
                                >
                                    {line.orderLinesPriceInfo.length > 0 ? (
                                        line.orderLinesPriceInfo.map((orderLinePriceInfo: any, index: number) => {
                                            return (
                                                <div key={index}>
                                                    <span>{orderLinePriceInfo.name}</span>
                                                    <span> - ${orderLinePriceInfo.price.toLocaleString()}</span>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <span>-</span>
                                    )}
                                </td>
                                <td style={{ width: 136 }}>{line.totalPrice}</td>
                                <td style={{ width: 145 }}>{line.Snapshotid ? line.Snapshotid : '-'}</td>
                                <td style={{ width: 145 }}>{line.statusName}</td>
                                <td>
                                    <Button
                                        className='ms-wishlist-items__product-add-button'
                                        title={'View Details'}
                                        onClick={() => props.getOrderDetailPageUrl(line.orderNumber, line.lineNum)}
                                    >
                                        {'View Details'}
                                    </Button>
                                </td>
                            </tr>
                        );
                    })}
                </table>
            </div>
            {props.currentPageItems.length > 0 && (
                <div style={style.pagination} className={'b2c-pagination'}>
                    <span style={props.activePage === 1 ? style.disabledWrapper : null}>
                        {' '}
                        <a
                            style={{ ...style.a, ...(props.activePage === 1 ? style.disabled : null) }}
                            onClick={() =>
                                props.activePage !== 1 ? props.handlePageItemsChange(props.totalItemPerPage, props.activePage - 1) : {}
                            }
                        >
                            &laquo;
                        </a>
                    </span>
                    {props.pageCount &&
                        [...Array(props.pageCount)].map((p: number, index: number) => {
                            return (
                                <a
                                    style={{
                                        ...style.a,
                                        ...(props.activePage === index + 1 ? style.active : null),
                                        ...(props.mouseOverIndex > 0 && props.mouseOverIndex === index + 1 ? style.hover : null)
                                    }}
                                    key={index + 1}
                                    onMouseEnter={() => props.handleMouseEnterEvent(index + 1)}
                                    onMouseLeave={() => props.handleMouseOutEvent()}
                                    onClick={() => props.handlePageItemsChange(props.totalItemPerPage, index + 1)}
                                >
                                    {index + 1}
                                </a>
                            );
                        })}
                    <span style={props.activePage === props.pageCount ? style.disabledWrapper : null}>
                        {' '}
                        <a
                            style={{ ...style.a, ...(props.activePage === props.pageCount ? style.disabled : null) }}
                            onClick={() =>
                                props.activePage !== props.pageCount
                                    ? props.handlePageItemsChange(props.totalItemPerPage, props.activePage + 1)
                                    : {}
                            }
                        >
                            &raquo;
                        </a>
                    </span>
                </div>
            )}
            {props.isLoading && <div>Loading...</div>}
            {!props.isLoading && (props.requestOrderLines.length === 0 || props.currentPageItems.length === 0) && (
                <div>
                    <div className='col-md-12 ms-order-history__empty-message-container'>
                        <p className='ms-order-history__empty-message'>{'You currently do not have any orders to view.'}</p>
                    </div>
                </div>
            )}
        </>
    );
};
